import React from "react"

import {PartialRoute} from "@irati/utils/history/routing"
import {LangLoader} from "@irati/utils/lang"
import {SETUP_TENANT, ADMIN} from "@irati-web/app/src/routeConfig"
import PartialRoutes from "./PartialRoutes"

interface Props {
  path: string
}

const IndexRoute = ({path}: Props) => (
  <LangLoader buckets={[SETUP_TENANT, ADMIN]}>
    <PartialRoute component={PartialRoutes} path={path} componentProps={{path}} />
  </LangLoader>
)

export default IndexRoute
